export default [
  {
    path: '/auth',
    name: 'Auth',
  },
  {
    path: '/new',
    name: 'New',
  },
  {
    path: '/complete',
    name: 'Complete',
  },
]
